import jwtAuthAxios from "./auth/jwtAuth";

const centreServices = {};

centreServices.getCentres = async (params) => {
    const {data} = await jwtAuthAxios.get(`/centres${params || ''}`);
    return data;
};

centreServices.getCentreOptions = async (id) => {
    const {data} = await jwtAuthAxios.get(`/centres/${id}/options`);
    return data;
};

centreServices.searchByCompany = async () => {
  const { data } = await jwtAuthAxios.get('/centres/search_by_company');
  return data;
};

export default centreServices;